import Image from 'app/Components/Shared/Image/image';
import React, {memo} from 'react';
import './ActionCard.scss';
import FuntoneButton from '../FuntoneButton/FuntoneButton';

const ActionCard = ({
  title = '',
  subtitle = '',
  buttonText = 'לניהול השירים',
  onButtonClick = () => {},
  image = null,
}) => {

  return (
   <div className="action-card">
     <div className={'action-card-container'}>
      <div className="action-card-inner">
        <div className="action-card-content">
          <div className="action-card-text">
            <span className="action-card-title">{title}</span>
            {subtitle && (
              <span className="action-card-subtitle">{subtitle}</span>
            )}
          </div>
          <FuntoneButton text={buttonText} onClick={onButtonClick} />
        </div>
        <div className="action-card-image">
          <Image src={image} alt="" />
        </div>
      </div>
      </div>
    </div>
  );
};

export default memo(ActionCard);
